<script>
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import sattalepmalzeme from "@/models/sattalepmalzeme";
import forminput from "../formcomponet/forminput.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import omalzemeAddEdit from "../omalzeme/addedit.vue";
import formcombobox from "../formcomponet/formcombobox.vue";

export default {
  props: ["Talepid", "OnayDurum", "Taleptoplamasontarih"],
  mixins: [apibtoast, apigeneric, sattalepmalzeme],
  page: {
    title: "Firmalar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    forminput,
    Treeselect,
    omalzemeAddEdit,
    formcombobox
  },
  data() {
    return {
      title: this.$t("sattalepmalzeme.Title"),
      items: [
        {
          text: this.$t("sattalepmalzeme.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("sattalepmalzeme.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("sattalepmalzeme.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "100",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      FormData: {},
      MalzemeGruplari: [],
      OlmayanMalzemeler: [],
      TumMalzemeler: [],
      MalzmeEkle: false,
      TalepAddEdit: "",
      FormDataMalzeme: {
        Grupid: null
      }
    };
  },
  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "SatTalepMalzeme",
        Page: this.Page,
        Filter: "&Asc=Sirano&Talepid=" + this.Talepid,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.FormData.Sirano = res.TotalCount + 1;


      });
    },
    malzemeleri_yukle(GrupData){
      let Page = {
          PageNumber: "1",
          PageSize: "9999",
        };
        this.FormDataType.Malzemeid.ComboDataArray = [];
        this.OlmayanMalzemeler = [];
        this.TumMalzemeler = [];
        this.ActionsFilterGet({ Service: "OMalzeme", Page: Page, Filter: "&Grupid=" + GrupData}).then((resMalzeme) => {
          for (var i = 0; i < resMalzeme.Data.length; i++) {
            var Kontrol = false;
            for (var SatirMalzeme in this.TableData) {
              if (resMalzeme.Data[i].Id == this.TableData[SatirMalzeme].Malzemeid) {
                Kontrol = true;
              }
            }
            var label = resMalzeme.Data[i].Adi;
            if (resMalzeme.Data[i].Aciklama) label += " ( " + resMalzeme.Data[i].Aciklama.slice(0, 25) + " ) ";
            this.TumMalzemeler.push({
              id: resMalzeme.Data[i].Id,
              label: label,
            });
            if (Kontrol == false) {
              this.OlmayanMalzemeler.push({
                id: resMalzeme.Data[i].Id,
                label: label,
              });
            }
           // this.FormDataType.Malzemeid.ComboDataArray = this.OlmayanMalzemeler;
            this.FormDataType.Malzemeid.ComboDataArray = this.TumMalzemeler;
          }
        });
    },
    malzeme_olcu(MalzemeData){
      this.ActionsSingleGet({ Service: "OMalzeme", Id: MalzemeData }).then((res) => {
        this.FormData.Olcubirimi = res.Data.Olcubirimi;
      });
    },
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit != "Edit") {
          this.Post("sattalepmalzeme", this.FormData).then((res) => {
            if (res) {
              let Bellek = JSON.parse(JSON.stringify(this.sattalepmalzemeData));
              this.FormData = Bellek;
              this.FormData.Talepid = this.Talepid;
              this.AddEdit = "Add";
              this.$emit("TableUpdate");
              this.$bvModal.hide("sattalepmalzeme");
            }
          });
        } else {
          this.Update("sattalepmalzeme", this.FormData).then((res) => {
            if (res) {
              const Bellek = JSON.parse(JSON.stringify(this.sattalepmalzemeData));
              this.FormData = Bellek;
              this.FormData.Talepid = this.Talepid;
              this.AddEdit = "Add";
              this.$emit("Update", this.FormData);
              this.$bvModal.hide("sattalepmalzeme");
              this.FormDataType.Malzemeid.ComboDataArray = this.OlmayanMalzemeler;
            }
          });
        }
      }
    },
  },
  watch: {
    Talepid() {
      this.FormData.Talepid = this.Talepid;
      this.Get();

    },
    AddEdit(){
      if(this.AddEdit == 'Edit'){
        this.ActionsSingleGet({
        Service: "omalzeme",
        Id: this.FormData.Malzemeid,
      }).then((res) => {
        this.FormDataMalzeme.Grupid = res.Data.Grupid;
        this.malzemeleri_yukle(this.FormDataMalzeme.Grupid)

      });

      }
    }
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    const Bellek = JSON.parse(JSON.stringify(this.sattalepmalzemeData));
    this.FormData = Bellek;
    this.FormData.Talepid = this.Talepid;
    this.ActionsGet({ "Service": "OMalzemeGrup", "Page": Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.MalzemeGruplari.push({ Id: res.Data[i].Id, Value: res.Data[i].Adi })
      }
    });
  },
};
</script>

<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-sm-12">
              <Form @submit.prevent="onSubmit" v-if="OnayDurum == 1"> 
                <div class="row" v-if="AddEdit =='Edit' || (AddEdit !='Edit' && !Taleptoplamasontarih)">
                  <div class="d-flex justify-content-between align-items-center">
                    <forminput 
                    :FormDataType="FormDataType.Sirano" 
                    :Value="FormData.Sirano" 
                    :v="$v.FormData.Sirano" 
                    @input="FormData.Sirano = $event" style="width:80px" 
                    
                    :Disabled="Taleptoplamasontarih ? true : false"
                    /> 
                    <formcombobox
                    v-if="!Taleptoplamasontarih ? true : false"
                     :FormDataType='{
                                FieldName: "Grupid",
                                Field: "combobox",
                                FieldTitle: this.$t("sattalep.AddEdit.Grupid"),
                                ComboDataArray: MalzemeGruplari,
                              }' :Value="FormDataMalzeme.Grupid" v=""
                              :disabled="(Taleptoplamasontarih ? true : false) || (this.AddEdit == 'Edit' ? true : false)"
                              @input="malzemeleri_yukle(FormDataMalzeme.Grupid = $event)" 
                              />
                    <b-form-group class="mb-3" id="example text" :label="FormDataType.Malzemeid.FieldTitle" label-for="text" style="width:280px">
                      <treeselect
                        :disabled="(Taleptoplamasontarih ? true : false) || (this.AddEdit == 'Edit' ? true : false)"
                        :multiple="false"
                        :options="FormDataType.Malzemeid.ComboDataArray"
                        :placeholder="$t('OrtakKullanim.seciniz')"
                        v-model="FormData.Malzemeid"
                        :class="{
                          'is-invalid': $v.FormData.Malzemeid.$error,
                        }"
                        @input="malzeme_olcu(FormData.Malzemeid = $event)"
                      />
                      <treeselect-value :value="FormData.Malzemeid" />
                      <div v-if="$v.FormData.Malzemeid.$error" class="invalid-feedback">
                        <span v-if="$v.FormData.Malzemeid.required == false">{{ $t("ValidationMessage.required") }}</span>
                      </div>
                    </b-form-group>

                    <i class="fas fa-plus" 
                    v-if="!Taleptoplamasontarih"
                    @click="(MalzmeEkle = true), (TalepAddEdit = 'TalepAdd')" 
                    v-b-modal.omalzeme></i>

                    <formcombobox
                      :FormDataType="FormDataType.Olcubirimi"
                      :Value="FormData.Olcubirimi"
                      :v="$v.FormData.Olcubirimi"
                      @input="FormData.Olcubirimi = $event"
                    />
                    <forminput 
                    :FormDataType="FormDataType.Adet" 
                    :Value="FormData.Adet" 
                    :v="$v.FormData.Adet" 
                    @input="FormData.Adet = $event" style="width:80px" />

                    <forminput 
                    :FormDataType="FormDataType.Aciklama" 
                    :Value="FormData.Aciklama" 
                    :v="$v.FormData.Aciklama" 
                    @input="FormData.Aciklama = $event" />
                 
                    <div class="mt-2" v-if="
                    (AddEdit != 'Edit' && !Taleptoplamasontarih) || 
                    AddEdit == 'Edit'">
                      <button class="btn btn-pink" type="submit">
                        {{ $t("sattalepmalzeme.AddEdit.Button") }}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-light">
                <tr>
                  <th>{{ $t("sattalepmalzeme.Table.Sirano") }}</th>
                  <th>{{ $t("sattalepmalzeme.Table.Malzemeid") }}</th>
                  <th>{{ $t("sattalepmalzeme.Table.OlcuBirimi") }}</th>
                  <th>{{ $t("sattalepmalzeme.Table.Miktar") }}</th>
                  <th>{{ $t("sattalepmalzeme.Table.Aciklama") }}</th>
                  <th v-if="OnayDurum == 1" style="width: 100px; text-align: center;">{{ $t("sattalepmalzeme.Table.Islem") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="Data in TableData" :key="Data.Id">
                  <th scope="row">{{ Data.Sirano }}</th>
                  <td>
                    {{ Data.Malzemeadi }}

                    <i v-if="Data.Malzemeaciklama" class="fas fa-info" v-tooltip="Data.Malzemeaciklama"></i>
                  </td>
                  <td>{{ Data.Olcubirimivalue }}</td>
                  <td>{{ Data.Adet }}</td>
                  <td>{{ Data.Aciklama }}</td>
                  <td v-if="OnayDurum == 1" style="width: 100px; text-align: center;">
                    <b-button-group>
                      <b-button variant="success" v-b-modal.sattalepmalzeme @click="(FormData = Data), (AddEdit = 'Edit'), (FormDataType.Malzemeid.ComboDataArray = TumMalzemeler)"><i class="far fa-edit"></i></b-button>
                      <b-button variant="danger" v-if="!Taleptoplamasontarih ? true : false" @click="Delete('sattalepmalzeme', Data.Id)"><i class="far fa-trash-alt"></i></b-button>
                    </b-button-group>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
          </div>
        </div>
      </div>
    </div>
    <omalzemeAddEdit v-if="MalzmeEkle" :AddEdit="TalepAddEdit" @TableUpdate="Get()" />
  </div>
</template>
